/**
 *  Note this file automatically generated from
 *  @link http://gitlab.fimacomarketing.com:10080/ProninE/BGServerGame/tree/master/ServerPHP/daemon/daemon_node/public/minigames/common/MinigameConnector.js
 */
'use strict';
import {SocketConnector} from 'minigame_client/support_connectors/base_connector/socket_connector';

/**
 * MinigameConnector class.
 *
 * About classes  https://learn.javascript.ru/class-inheritance
 * @inheritDoc
 */

export function MinigameConnector(socket, minigame_id) {
    SocketConnector.apply(this, arguments);
    // SocketConnector.call(this, socket);
    this.verbose_name = "MinigameConnector:";
    this.emit_name = "minigameRpc";

    this.minigame_id = minigame_id;

    this.__setupConstants();
    var self = this;
    this.cb_model_changed = function(data) { self.__log("cb_model_changed", data); };
    this.__setupCallbacks();
}



MinigameConnector.prototype = Object.create(SocketConnector.prototype);
MinigameConnector.prototype.constructor = MinigameConnector;


MinigameConnector.prototype.__setupConstants = function() {
    this.MINIGAME_ID_COIN      = 1;
    this.E_MINIGAME_21         = 2;
    this.E_MINIGAME_ROULETTE   = 3;
};


MinigameConnector.prototype.__setupCallbacks = function() {
    var self = this;

    this.socket.on("user_info", function(data) {
        self.my_uuid = data.uuid;
    });

    this.socket.on("user_info", function(data) {
        self.player_info = data;
    });

    this.socket.on("minigameModelChanged", function(data) {
        var minigame_id = data.minigame_id;
        if(minigame_id !== self.minigame_id)
            return;
        //self.__log("minigameModelChanged", data);
        if(data.trace)
            self.__log("Trace url",data.trace);
        self.cb_model_changed(data);
    });
};




/**
 * callback when game list changed.
 * @param cb
 */
MinigameConnector.prototype.setCallbackModelChanged = function(cb) {
    this.__log("setCallbackModelChanged");
    this.cb_model_changed = cb;
};


/**
 * get model of current state
 * @param cb function | null
 */
MinigameConnector.prototype.doModelGet = function(cb = null) {
    var self = this;
    this.__call("get-model", {
        minigame_id: self.minigame_id
    }, cb);
};


/**
 @typedef currency
 @type {Object}
 @property {string} code_name
 @property {number} id
 */


/**
 @typedef bet
 @type {Object}
 @property {number} value
 @property {currency} currency
 */



/**
 * get model of current state
 * @param method  string
 * @param params  Object
 *
 * @param cb function
 */
MinigameConnector.prototype.doAction = function(method, params, cb) {
    this.__call("action", {
        minigame_id: this.minigame_id,
        action: {
            "method" : method,
            "params" : params
        }
    }, cb);
};




//////////////////
// WEBPACK FOOTER
// ./src/library/minigame_client/common/MinigameConnector.js
// module id = 122
// module chunks = 0